module.exports = __webpack_public_path__ + "img/FTHS__FantasyShield.94277ea8.png";